/* CozySpun Home: delivery estimate (US). Holiday cutoff removed. Business days skip Sat/Sun. */
(function () {
  if (window.customElements && customElements.get('cs-delivery-estimate')) return;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function today() {
    try {
      var m = /[?&]cs_today=(\d{4})-(\d{2})-(\d{2})/.exec(window.location.search);
      if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
    } catch (e) {}
    var n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate());
  }
  function isBiz(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
  function addBiz(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() + 1); if (isBiz(r)) n--; }
    return r;
  }
  function subBiz(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() - 1); if (isBiz(r)) n--; }
    return r;
  }
  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  // Product delivery estimate stays a business-day range and does not add a holiday promise.
  // The cart summary has its own estimated US Christmas cutoff (see the countdown below).
  window.CozySpunDelivery = { addBiz: addBiz, today: today };

  class Estimate extends HTMLElement {
    connectedCallback() { render(this); }
  }
  function render(el) {
    var t = today();
    var min = parseInt(el.getAttribute('data-min') || '6', 10);
    var max = parseInt(el.getAttribute('data-max') || '9', 10);
    var dest = el.getAttribute('data-dest') || 'US';
    var main = el.querySelector('[data-cs-text]');
    if (main) {
      main.textContent = 'Order today, estimated ' + dest + ' delivery ' + fmt(addBiz(t, min)) + ' \u2013 ' + fmt(addBiz(t, max));
    }
    // Never show a holiday/Christmas promise on the delivery estimate module (PDP or cart).
    var hol = el.querySelector('[data-cs-holiday]');
    if (hol) { hol.hidden = true; hol.textContent = ''; }
  }
  customElements.define('cs-delivery-estimate', Estimate);
})();

/* CozySpun PDP pair upsell ATC + color select */
(function () {
  if (window.__csPairUpsellBound) return;
  window.__csPairUpsellBound = true;

  function openCartDrawer() {
    try {
      var drawer = document.querySelector('cart-drawer-component theme-drawer, cart-drawer theme-drawer, theme-drawer[id*="cart"]');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      var cartDrawer = document.querySelector('cart-drawer-component, cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return true;
      }
    } catch (e) {}
    return false;
  }

  async function refreshCartUI() {
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) {}
    try {
      var res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (res.ok) {
        var cart = await res.json();
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      }
    } catch (e) {}
  }

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; }
  }

  function parseVariants(root) {
    var parsed = parseJSON(root.querySelector('[data-cs-pair-variants]'));
    return Array.isArray(parsed) ? parsed : [];
  }

  function parseCatalog(root) {
    var data = parseJSON(root.querySelector('[data-cs-pair-catalog]'));
    if (Array.isArray(data) && data.length) return data;
    var titleEl = root.querySelector('[data-cs-pair-title]');
    return [{
      handle: root.getAttribute('data-cs-pair-product') || '',
      title: titleEl ? titleEl.textContent.trim() : '',
      url: titleEl ? titleEl.getAttribute('href') : '#',
      colorOptionName: null,
      colorOptionIndex: null,
      colorValues: [],
      variants: parseVariants(root)
    }];
  }

  function firstVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    return product.variants[0];
  }

  function rebuildColorSelect(root, product) {
    var host = root.querySelector('[data-cs-pair-swatch-host]');
    if (!host) return;
    host.innerHTML = '';
    if (!product || !product.colorOptionName || !product.colorValues || product.colorValues.length < 2) {
      host.hidden = true;
      return;
    }
    host.hidden = false;
    var label = document.createElement('label');
    label.className = 'cs-pair-upsell__swatch-label';
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = product.colorOptionName;
    var sel = document.createElement('select');
    sel.className = 'cs-pair-upsell__color';
    sel.setAttribute('data-cs-pair-color', '');
    sel.setAttribute('data-option-index', String(product.colorOptionIndex == null ? 0 : product.colorOptionIndex));
    sel.setAttribute('aria-label', product.colorOptionName);
    var active = firstVariant(product);
    var activeVal = active && active.options ? active.options[product.colorOptionIndex || 0] : null;
    for (var i = 0; i < product.colorValues.length; i++) {
      var opt = document.createElement('option');
      opt.value = product.colorValues[i];
      opt.textContent = product.colorValues[i];
      if (activeVal && product.colorValues[i] === activeVal) opt.selected = true;
      sel.appendChild(opt);
    }
    label.appendChild(sr);
    label.appendChild(sel);
    host.appendChild(label);
  }

  function applyProduct(root, product) {
    if (!product) return;
    root.setAttribute('data-cs-pair-product', product.handle || '');
    var title = root.querySelector('[data-cs-pair-title]');
    var link = root.querySelector('[data-cs-pair-link]');
    var img = root.querySelector('[data-cs-pair-img]');
    if (title) {
      title.textContent = product.title || '';
      if (product.url) title.setAttribute('href', product.url);
    }
    if (link) {
      if (product.url) link.setAttribute('href', product.url);
      if (product.title) link.setAttribute('aria-label', product.title);
    }
    var variant = firstVariant(product);
    if (img && variant && variant.image && img.tagName === 'IMG') {
      img.src = variant.image;
      img.removeAttribute('srcset');
      img.alt = product.title || '';
    }
    applyVariant(root, variant);
    rebuildColorSelect(root, product);
    var legacy = root.querySelector('[data-cs-pair-variants]');
    if (legacy) {
      try { legacy.textContent = JSON.stringify(product.variants || []); } catch (e) {}
    }
  }

  function applyVariant(root, variant) {
    if (!variant) return;
    var btn = root.querySelector('[data-cs-pair-add]');
    var price = root.querySelector('[data-cs-pair-price]');
    var img = root.querySelector('[data-cs-pair-img]');
    if (btn) btn.setAttribute('data-variant-id', String(variant.id));
    if (price && variant.price) price.textContent = variant.price;
    if (img && variant.image) {
      if (img.tagName === 'IMG') {
        img.src = variant.image;
        img.removeAttribute('srcset');
      }
    }
  }

  document.addEventListener('change', function (ev) {
    var pick = ev.target && ev.target.closest ? ev.target.closest('[data-cs-pair-pick]') : null;
    if (pick) {
      var pickRoot = pick.closest('.cs-pair-upsell');
      if (!pickRoot) return;
      var catalog = parseCatalog(pickRoot);
      var chosen = null;
      for (var c = 0; c < catalog.length; c++) {
        if (catalog[c].handle === pick.value) { chosen = catalog[c]; break; }
      }
      applyProduct(pickRoot, chosen);
      return;
    }

    var sel = ev.target && ev.target.closest ? ev.target.closest('[data-cs-pair-color]') : null;
    if (!sel) return;
    var root = sel.closest('.cs-pair-upsell');
    if (!root) return;
    var catalogForColor = parseCatalog(root);
    var handle = root.getAttribute('data-cs-pair-product');
    var product = null;
    for (var p = 0; p < catalogForColor.length; p++) {
      if (catalogForColor[p].handle === handle) { product = catalogForColor[p]; break; }
    }
    var variants = product && product.variants ? product.variants : parseVariants(root);
    var optIndex = parseInt(sel.getAttribute('data-option-index') || '0', 10);
    var value = sel.value;
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var opts = variants[i].options || [];
      if (opts[optIndex] === value) { match = variants[i]; break; }
    }
    applyVariant(root, match);
  });

  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('[data-cs-pair-add]') : null;
    if (!btn) return;
    ev.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var root = btn.closest('.cs-pair-upsell');
    var status = root ? root.querySelector('[data-cs-pair-status]') : null;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    if (status) { status.hidden = true; status.removeAttribute('data-ok'); }

    var sectionIds = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
    });

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var msg = (data && (data.description || data.message)) || 'Could not add to cart';
          throw new Error(msg);
        }
        return data;
      });
    }).then(function (data) {
      try {
        var update = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
        update.action = 'add';
        update.promise = Promise.resolve({
          detail: { sections: (data && data.sections) || {} }
        });
        document.dispatchEvent(update);
      } catch (e) {}
      return refreshCartUI().then(function () {
        if (status) {
          status.hidden = false;
          status.setAttribute('data-ok', '1');
          status.textContent = 'Added — check your cart for Mix & Match and free-shipping progress.';
        }
        openCartDrawer();
      });
    }).catch(function (err) {
      if (status) {
        status.hidden = false;
        status.setAttribute('data-ok', '0');
        status.textContent = err && err.message ? err.message : 'Could not add to cart';
      }
    }).finally(function () {
      btn.disabled = false;
      btn.textContent = label;
    });
  });
})();

/* Cart / cart drawer: estimated US Christmas delivery cutoff.
   The deadline is the data-cs-xmas-cutoff attribute (Dec 11, 2026, 11:59 PM PT).
   More than 48 hours out, the line names that date. Inside 48 hours it counts
   down in days, hours, and minutes — never a "45d 21:25:28" clock. Hidden after. */
(function () {
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var TWO_DAYS = 2 * 24 * 60 * 60 * 1000;

  function nowMs() {
    try {
      var m = /[?&]cs_now=([^&]+)/.exec(window.location.search);
      if (m) {
        var t = Date.parse(decodeURIComponent(m[1].replace(/\+/g, ' ')));
        if (isFinite(t)) return t;
      }
    } catch (e) {}
    return Date.now();
  }

  function labelFromIso(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
    if (!m) return '';
    var month = MONTHS[+m[2] - 1];
    var day = +m[3];
    if (!month || !(day >= 1 && day <= 31)) return '';
    return month + ' ' + day;
  }

  function unit(n, one, many) {
    return n + ' ' + (n === 1 ? one : many);
  }

  function describe(remainingMs, cutoffLabel) {
    if (!(remainingMs > 0) || !cutoffLabel) return null;
    if (remainingMs > TWO_DAYS) return { lead: 'Order by ', when: cutoffLabel };
    var minute = 60 * 1000;
    var hour = 60 * minute;
    var day = 24 * hour;
    var days = Math.floor(remainingMs / day);
    var hours = Math.floor((remainingMs % day) / hour);
    var minutes = Math.floor((remainingMs % hour) / minute);
    var when;
    if (days >= 1) {
      when = unit(days, 'day', 'days');
      if (hours > 0) when += ' ' + unit(hours, 'hour', 'hours');
    } else if (hours >= 1) {
      when = unit(hours, 'hour', 'hours');
      if (minutes > 0) when += ' ' + unit(minutes, 'minute', 'minutes');
    } else {
      when = unit(Math.max(1, minutes), 'minute', 'minutes');
    }
    return { lead: 'Order within ', when: when };
  }

  function paint(el) {
    var iso = el.getAttribute('data-cs-xmas-cutoff');
    var end = Date.parse(iso);
    var text = describe(end - nowMs(), labelFromIso(iso));
    var lead = el.querySelector('[data-cs-xmas-lead]');
    var when = el.querySelector('[data-cs-xmas-when]');
    if (!text || !isFinite(end) || !lead || !when) {
      el.hidden = true;
      return;
    }
    if (lead.textContent !== text.lead) lead.textContent = text.lead;
    if (when.textContent !== text.when) when.textContent = text.when;
    if (el.hidden) el.hidden = false;
  }

  function tick() {
    var nodes = document.querySelectorAll('[data-cs-xmas-cutoff]');
    for (var i = 0; i < nodes.length; i++) paint(nodes[i]);
  }

  function start() {
    tick();
    setInterval(tick, 30000);
  }

  window.CozySpunXmasCutoff = { describe: describe, labelFromIso: labelFromIso, nowMs: nowMs };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
